import analytics from '@react-native-firebase/analytics';
import crashlytics from '@react-native-firebase/crashlytics';

export default class FirebaseService {
  static logEvent(event = '', params = {}) {
    try {
      if (__DEV__) return;
      if (event?.indexOf(' ') > 0) {
        event = event.split(' ').join('_');
      }
      analytics().logEvent(event, params);
    } catch (err) {
      FirebaseService.logError(err);
    }
  }

  static logError(error, errorInfo) {
    try {
      const exception = error instanceof Error ? error : new Error(FirebaseService.getErrorMessage(error));
      if (errorInfo?.componentStack) crashlytics().log(errorInfo.componentStack);
      crashlytics().recordError(exception, exception.name);
    } catch {
      return null;
    }
  }

  static getErrorMessage(error) {
    if (typeof error === 'string') return error;
    try {
      return JSON.stringify(error) || 'Unknown error';
    } catch {
      return String(error);
    }
  }

  static async logScreen(screenName) {
    if (typeof screenName !== 'string' || screenName.trim().length === 0) return;

    try {
      await analytics().logScreenView({ screen_name: screenName.trim() });
    } catch (error) {
      FirebaseService.logError(error);
    }
  }

  static async getGclid() {
    return null;
  }

  static async getInstanceId() {
    try {
      const instanceId = await analytics().getAppInstanceId();
      return instanceId;
    } catch (error) {
      console.error('Error getting campaign data:', error);
    }
    return null;
  }
}
